// src/recently-viewed/recentlyViewedApi.ts
import { apiClient } from "@maat/api-base";
var recentlyViewedApi = {
  list: async (params) => {
    return apiClient.get("/main/api/recently-viewed", { params });
  },
  record: async (payload) => {
    await apiClient.post("/main/api/recently-viewed", payload);
  }
};

export {
  recentlyViewedApi
};
